module.exports = __webpack_public_path__ + "img/class.6779280e.svg";